export default __webpack_public_path__ + "static/media/kilans.d0c4ffae.png";